<template>
	<div class="product-details">
		<!-- 顶部信息 -->
		<shortcut-bar class="shortcut-bar page-header" />
		<div class="page-header-placeholder"></div>

		<!-- 搜索 -->
		<div ref="productSearch" class="home-center-search">
			<div class="search-box">
				<div class="search-box-input flex align-center">
					<img src="../../../static/images/icon/icon11.png" alt="">
					<input type="text" :placeholder="$t('请输入您想搜索的内容')" v-model="keyword" @keyup.enter="onSearch">
				</div>
				<div class="search-box-btn" @click="onSearch">{{ $t('搜索') }}</div>
			</div>
		</div>

		<!-- 主要信息 -->
		<div v-if="detailLoaded" class="detail-card">
			<div ref="productMain" class="main-area">

				<div ref="productImage" class="img-area">
					<div class="left_img">
						<img :src="img" alt="" v-for="(img, index) in img_list" :key="index"
							@mouseenter="onImgMouseenter(index)" @click="onImgMouseenter(index)">
					</div>
					<img :src="img_detail" class="goodsimg">
				</div>

				<div ref="productInfo" class="product-info">
					<div>
						<div class="title">
							<span class="name">{{ detail.name }}</span>
							<div v-if="detail.product_type" class="tag">
								{{ detail.product_type ? $t('虚拟商品') : '' }}
							</div>
						</div>
						<div class="main-details">
							<div class="flex justify-between margin-bottom-32">
								<div class="text-14">
									￥<span class="price">{{ price }}</span>
								</div>
								<div class="text-16 text-999">{{ $t('已售') }} {{ detail.sales }}</div>
							</div>
							<div class="">
								<div class="text-16">
									<span class="margin-right-8 text-999">{{ $t('配送：') }}</span>
									<span>
										{{ siteData.province_name }}{{ siteData.city_name }}{{ siteData.district_name
										}}{{
										siteData.address }}
									</span>
								</div>
								<div class="arrival-time text-999" v-if="detail.free_shipping">
									{{ $t('快递：') }}{{ $t('免运费') }}
								</div>
								<div class="arrival-time text-999" v-else>
									{{ $t('快递：') }}{{ $t('满') }} {{ detail.free_shipping_money }} {{ $t('包邮') }}
								</div>
							</div>

							<div class="flex text-16 margin-top-24" v-if="sku_data.length">
								<div class="margin-right-8 text-999 sku-label">{{ $t('规格：') }}</div>
								<div class="sku_box">
									<div class="sku_item" v-for="(item, index) in sku_data" :key="index"
										@click="sku_price_id = item.id, price = item.price"
										:class="sku_price_id == item.id ? 'sku_pitch' : ''">
										{{ item.name }}
										<span class="margin-left-8 text-14 text-999">
											{{ $t('剩余') }}{{ item.stock }}{{ $t('件') }}
										</span>
									</div>
								</div>
							</div>

							<div class="flex text-16 margin-top-24 num-row">
								<div class="margin-right-8 text-999 sku-label">{{ $t('数量：') }}</div>
								<el-input-number v-model="productNum" @change="handleChange" :min="1"
									:max="10"></el-input-number>
							</div>
						</div>
					</div>
					<!-- 操作 -->
					<div class="operation">
						<div class="operation-right" @click="onCollect">
							<img src="../../../static/images/icon/icon18.png" alt="" v-if="is_collect == 0">
							<img src="../../../static/images/icon/icon35.png" alt="" v-if="is_collect == 1">
							<span>{{ $t('收藏') }}</span>
						</div>
						<div class="operation-left" v-if="true">
							<div class="operation-left-r" v-if="detail.product_type != 1" @click="onAddCart">
								<img src="../../../static/images/icon/icon07.png" alt="">
							</div>
							<div class="operation-left-l" @click="placeOrder">{{ $t('立即购买') }}</div>
						</div>
						<div class="operation-download" v-else>{{ $t('下载') }}</div>
					</div>
				</div>
			</div>
			<!-- 下方其他信息 -->
			<div ref="productMoreInfo" class="other-info">
				<!-- 产品的一些信息 -->
				<more-info :detail="detail" ref="MoreInfo"></more-info>
			</div>
		</div>
		<div v-else class="detail-card detail-card-loading">
			<i class="el-icon-loading"></i>
		</div>

		<!-- 添加成功弹窗 -->
		<div class="succeedPop" v-if="add_show">
			<div class="succeedPop-box">
				<div class="justify-end" style="width: 100%;">
					<i class="el-icon-close box-icon" @click="add_show = false"></i>
				</div>
				<img src="../../../static/images/icon/icon19.png" alt="">
				<div class="text-16">{{ $t('成功加入购物车') }}</div>
				<div class="box-btn" @click="goCart">{{ $t('去购物车') }}</div>
			</div>
		</div>

		<!-- 未选sku -->
		<div class="pop" v-if="show">
			<img src="../../../static/images/icon/icon34.png" alt="">
			<p>{{ $t('请选择规格信息') }}</p>
		</div>
		<div class="pc-float">
			<!-- 右侧悬浮框 -->
			<rightSuspension />
			<!-- 左侧悬浮框 -->
			<leftSuspension />
		</div>

		<footer-bar></footer-bar>
	</div>
</template>

<script>
	import MoreInfo from './components/MoreInfo'
	import { getToken } from '@/utils/auth'

	import ShortcutBar from '@/components/ShortcutBar';
	import rightSuspension from "@/components/rightSuspension.vue";
	import leftSuspension from "@/components/leftSuspension.vue";
	import footerBar from '@/components/footerBar';

	import { commodityDetail, commodityCollect, addCart, siteList } from '@/api/user';

	export default {
		name: 'ProductDetails',
		components: {
			'more-info': MoreInfo,
			'footer-bar': footerBar,
			'shortcut-bar': ShortcutBar,
			rightSuspension,
			leftSuspension,
		},
		data() {
			return {
				allProducts: {},
				discounts: ['满50减5', '满99减20', '满199减50', '满299减100'],
				rateValue: 5,
				keyword: '',//搜索内容
				img_list: [],//轮播图列表
				img_detail: '',//大图
				add_show: false,//购物车添加成功弹窗
				id: '',//商品id
				detail: {},//商品详情
				detailLoaded: false,//商品详情接口是否加载完成
				price: '',//价格
				sku_price_id: '',//skuid
				show: false,//未选规格弹窗
				timeoutId: null, // 用于存储定时器
				productNum: 1,//数量
				is_collect: 0,//是否收藏
				sku_data: [],//商品规格
				siteData: {},//地址信息
				// 商品详情入场动画实例，用于组件销毁时释放动画资源
				productEntranceAnimation: null,
			}
		},
		computed: {
			recommendedIds: function () {
				var tempArr = [];
				// 十位数
				var tensDigit = Math.floor((this.$route.params.id - 1) / 10) * 10;
				for (var i = 1; i <= 10; i++) {
					var id = tensDigit + i;
					if (id != this.$route.params.id) {
						tempArr.push(id);
					}
				}
				return tempArr;
			},
		},
		mounted() {
			this.id = this.$route.params.id
			this.onDetail()
			let userToken = getToken()
			if (userToken) {
				this.onSiteList()
			}
		},
		beforeDestroy() {
			if (this.productEntranceAnimation) {
				this.productEntranceAnimation.kill()
			}
		},
		methods: {
			/** 播放商品详情各区域的入场动效 */
			playProductEntranceAnimation() {
				if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					return
				}
				if (this.productEntranceAnimation) {
					this.productEntranceAnimation.kill()
				}
				this.productEntranceAnimation = this.$gsap.timeline()
					.from(this.$refs.productSearch, { y: -12, duration: 0.35, ease: 'power2.out' })
					.from(this.$refs.productImage, { x: -24, duration: 0.5, ease: 'power2.out' })
					.from(this.$refs.productInfo, { x: 24, duration: 0.5, ease: 'power2.out' }, '<0.08')
					.from(this.$refs.productMoreInfo, { y: 20, duration: 0.45, ease: 'power2.out' }, '<0.12')
					.eventCallback('onComplete', () => {
						this.$gsap.set([
							this.$refs.productSearch,
							this.$refs.productImage,
							this.$refs.productInfo,
							this.$refs.productMoreInfo,
						], { clearProps: 'transform' })
					})
			},
			/**地址列表 */
			onSiteList() {
				siteList().then(res => {
					// console.log(res.data);
					let list = res.data
					list.forEach(e => {
						if (e.is_default) {
							// console.log(e);
							this.siteData = e
						}
					})
					// this.tableData = res.data
				})
			},
			/**加入购物车 */
			goCart() {
				this.$router.push({ name: 'ShoppingCart', params: { type: 1 } });
			},
			/**收藏 */
			onCollect() {
				commodityCollect({ id: this.id }).then(res => {
					if (res.code == 1) {
						if (this.is_collect == 1) {
							this.$message.success(this.$t('已取消'));
							this.is_collect = 0
						} else {
							this.$message.success('已收藏');
							this.is_collect = 1
						}
					}
				})
			},
			/**商品详情 */
			onDetail() {
				commodityDetail({ id: this.id }).then(res => {
					let data = res.data
					// console.log(data);
					this.img_list = data.covers
					this.img_detail = data.covers[0]
					this.detail = data
					this.price = data.price
					this.sku_data = data.sku_data
					this.is_collect = this.detail.is_collect
					this.detailLoaded = true
					this.$nextTick(() => {
						this.$refs.MoreInfo.onDetail(this.detail)
					})
				})
			},
			/**添加购物车 */
			onAddCart() {
				clearTimeout(this.timeoutId);
				if (this.sku_data.length) {
					if (!this.sku_price_id) {
						this.show = true
						this.timeoutId = setTimeout(() => {
							this.show = false
						}, 1500);
						return
					}
				}

				this.show = false
				let data = {
					product_id: this.id,
					sku_price_id: this.sku_price_id,
					type: 'cover',
					num: this.productNum,
					id: 0
				}

				addCart(data).then(res => {
					if (res.code == 1) {
						this.$message.success('添加成功');
						this.add_show = true
					}
				})
			},
			/**鼠标滑动 */
			onImgMouseenter(i) {
				this.img_detail = this.img_list[i]
			},
			/**搜索 */
			onSearch() {
				if (this.keyword) {
					this.$router.push({ name: 'Search', params: { keyword: this.keyword } })
				}
			},
			/**下单 */
			placeOrder() {
				clearTimeout(this.timeoutId);
				if (this.sku_data.length) {
					if (!this.sku_price_id) {
						this.show = true
						this.timeoutId = setTimeout(() => {
							this.show = false
						}, 1500);
						return
					}
				}

				this.show = false
				let goods_list = [{
					product_id: this.id,
					sku_price_id: this.sku_price_id,
					num: this.productNum
				}]

				console.log(goods_list);
				this.$router.push({ name: 'orders', params: { order: encodeURIComponent(JSON.stringify(goods_list)) } })
			},
			/**数量修改 */
			handleChange(value) {
				this.productNum = value
			},
		},
	};
</script>

<style scoped lang="scss">
	/* 组件的最外层标签 */
	.product-details {
		width: 100%;
		font-size: 14px;
		background: #FFFFFF;
	}

	.page-header {
		z-index: 999;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.page-header-placeholder {
		height: 56px;
	}

	.detail-card {
		box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
		margin: 0 var(--page-gutter-wide);
		padding: 0 24px;
		border-radius: 8px;
		box-sizing: border-box;

		&.detail-card-loading {
			min-height: 480px;
			display: flex;
			align-items: center;
			justify-content: center;

			i {
				font-size: 28px;
				color: #000000;
			}
		}
	}

	.sku-label {
		width: 48px;
		flex-shrink: 0;
	}

	/**搜索 */
	.home-center-search {
		padding: 32px var(--page-gutter-wide);

		.search-box {
			width: 100%;
			height: 46px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #F8F8F8;
			box-sizing: border-box;
			border-radius: 30px;

			.search-box-input {
				width: calc(100% - 100px);
			}

			img {
				width: 18px;
				height: 18px;
				margin-right: 14px;
				margin-left: 22px;
			}

			.search-box-btn {
				height: 100%;
				background: #000000;
				font-size: 14px;
				color: #FFFFFF;
				padding: 0 26px;
				line-height: 46px;
				border-radius: 30px;
				cursor: pointer;
			}

			input {
				background: #F8F8F8;
				width: 90%;
			}
		}
	}

	/* 店铺 */
	.store-item {
		width: 1280px;
		height: 64px;
		margin: 16px auto;
		padding: 0 24px;
		background: #FFFFFF;
		box-sizing: border-box;
		border-radius: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.store-item .store-img {
		width: 48px;
		height: 48px;
		margin-right: 12px;
		border-radius: 8px;
	}

	/* PC 端商品详情内容区与首页保持一致，固定使用 1280px 页面栅格。 */
	@media (min-width: 768px) {
		.home-center-search,
		.detail-card,
		.store-item {
			width: 1280px;
			margin-left: auto;
			margin-right: auto;
			box-sizing: border-box;
		}

		.home-center-search {
			padding: 32px 0;
		}

		.detail-card {
			margin-top: 0;
			margin-bottom: 0;
		}
	}

	/* 主要信息 */
	.product-details .main-area {
		padding: 32px 0;
		margin: 0 auto;
		position: relative;
		box-sizing: border-box;
		background-color: #fff;
		display: flex;
		align-items: stretch;
		gap: 24px;

		@media (min-width: 1440px) {
			gap: 36px;
		}
	}

	.product-details .main-area::after {
		content: none;
	}

	/* 商品图片 */
	.left_img {
		width: 80px;
		height: 340px;
		margin-right: 12px;
		border-radius: 8px;
		overflow-y: auto;
		flex-shrink: 0;

		@media (min-width: 1024px) {
			height: 420px;
		}

		@media (min-width: 1280px) {
			width: 104px;
			height: 560px;
			margin-right: 16px;
		}
	}

	/* 隐藏滚动条 */
	.left_img::-webkit-scrollbar {
		display: none;
		/* Chrome, Safari */
	}

	.left_img img {
		width: 80px;
		height: 80px;
		border-radius: 8px;
		display: block;
		margin-bottom: 10px;
		object-fit: cover;
		cursor: pointer;

		@media (min-width: 1280px) {
			width: 104px;
			height: 104px;
		}
	}

	.left_img img:last-child {
		margin-bottom: 0;
	}

	.product-details .main-area .img-area {
		width: auto;
		height: auto;
		float: none;
		display: flex;
		flex-shrink: 0;
	}

	.product-details .main-area .img-area .goodsimg {
		width: 340px;
		height: 340px;
		box-sizing: border-box;
		border-radius: 8px;
		object-fit: cover;
		display: block;

		@media (min-width: 1024px) {
			width: 420px;
			height: 420px;
		}

		@media (min-width: 1280px) {
			width: 560px;
			height: 560px;
		}
	}

	/* 商品信息1 */
	.product-details .main-area .product-info {
		width: auto;
		flex: 1;
		min-width: 0;
		height: auto;
		min-height: 360px;
		float: none;
		box-sizing: border-box;
		padding-left: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.product-details .main-area .product-info .title {
		margin-bottom: 16px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
	}

	.product-details .main-area .product-info .title .company-name {
		font-size: 14px;
		padding: 2px;
		background-color: #ef1234;
		color: #fff;
		vertical-align: 1px;
		border-radius: 2px;
	}

	.product-details .main-area .product-info .title .name {
		font-size: 20px;
		font-weight: bold;
		min-width: 0;
		word-break: break-word;
	}

	.product-details .main-area .product-info .title .tag {
		font-size: 14px;
		margin-left: 12px;
		padding: 4px 16px;
		color: #000000;
		border: 1px solid #000000;
		border-radius: 6px;
	}

	/* 主要细节 */
	.product-details .main-area .product-info .main-details {
		font-size: 12px;
		color: #666;
		position: relative;
		min-height: 100px;
		box-sizing: border-box;
	}

	/* 价格 */
	.product-details .main-area .product-info .main-details .price {
		color: #85674B;
		font-size: 28px;
		/* // padding: 0 10px; */
		/* // vertical-align: -3px; */
	}

	.crossedPrice {
		color: #999;
		font-size: 14px;
		text-decoration: line-through;
	}

	/* 规格 */
	.sku_box {
		display: flex;
		flex-wrap: wrap;
		width: calc(100% - 56px);
		height: auto;
		max-height: 154px;
		overflow-y: auto;
	}

	/* 隐藏滚动条 */
	.sku_box::-webkit-scrollbar {
		display: none;
		/* Chrome, Safari */
	}

	.sku_box .sku_item {
		height: 36px;
		padding: 8px 12px;
		margin: 0 20px 12px 0;
		background: #FFFFFF;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #EEEEEE;
		cursor: pointer;
		font-size: 16px;
	}

	.sku_box .sku_pitch {
		color: #61AC85;
		border: 1px solid #61AC85;
	}

	/* 地址 */
	.product-details .main-area .product-info .main-details .delivery-address {
		border: 1px solid #ccc;
		padding: 5px;
		margin: 0 10px;
	}

	.product-details .main-area .product-info .main-details .in-stock {
		/*color: #424242;*/
		/*font-size: 14px;*/
		font-weight: 600;
	}

	.product-details .main-area .product-info .main-details .arrival-time {
		margin-left: 50px;
		margin-top: 4px;
		font-size: 14px;
	}

	.product-details .main-area .product-info .main-details .arrival-time .company {
		color: #ef1234;
	}

	/* 商品数量 */
	.product-num {
		float: left;
		width: 120px;
		height: 30px;
		border: 1px solid #ccc;
		position: relative;
		/*display: */
		/*box-sizing: border-box;*/
	}

	.product-num>* {
		position: absolute;
		top: 0;
		text-align: center;
		width: 25%;
		height: 30px;
		line-height: 30px;
		background-color: #eee;
		font-size: 20px;
		border: none;
	}

	.product-num .add {
		left: 90px;
		cursor: pointer;
	}

	.product-num .subtract {
		cursor: pointer;
	}

	.product-num span.inactive {
		cursor: default;
		color: #ccc;
	}

	.product-num .number {
		left: 30px;
		width: 50%;
		box-sizing: border-box;
		border-left: 1px solid #ccc;
		border-right: 1px solid #ccc;
		background-color: #fff;
		outline: none;
		font-size: 16px;
	}

	/* 加入购物车/立即下单 */
	/* 操作 */
	.product-info .collect {
		color: #666;
		font-size: 14px;
		margin-left: 16px;
	}

	.product-info .collect img {
		width: 24px;
		height: 24px;
	}

	.product-details .main-area .product-info .operation {
		/*margin-top: 10px;*/
		padding-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.operation-left {
		width: calc(100% - 50px);
		display: flex;
		align-items: center;
		min-width: 0;

		.operation-left-l {
			flex: 1;
			width: auto;
			max-width: 340px;
			height: 48px;
			background: #333333;
			border-radius: 8px;
			font-size: 16px;
			color: #FFFFFF;
			text-align: center;
			line-height: 48px;
			margin-left: 20px;
			cursor: pointer;
		}

		.operation-left-r {
			width: 128px;
			height: 48px;
			background: #FFFFFF;
			border: 1px solid #EEEEEE;
			border-radius: 8px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			img {
				width: 24px;
				height: 24px;
			}
		}
	}

	.operation-download {
		width: 100%;
		max-width: 470px;
		height: 48px;
		background: #333333;
		border-radius: 8px;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		line-height: 48px;
		margin-right: 20px;
		cursor: pointer;
	}

	.operation-right {
		display: flex;
		flex-direction: column;
		align-items: center;
		cursor: pointer;

		img {
			width: 24px;
			height: 24px;
		}

		span {
			font-size: 14px;
			color: #666666;
			margin-top: 6px;
		}
	}

	/* 下方其他信息 */
	.product-details .other-info {
		/* // padding: 0 320px; */
		overflow: hidden;
		margin-bottom: 40px;
		padding-bottom: 32px;
		background-color: #fff;
	}

	/**添加成功弹窗 */
	.succeedPop {
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;

		.succeedPop-box {
			padding: 20px 20px 48px;
			background: #FFFFFF;
			border-radius: 8px;
			width: 400px;
			height: 296px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;

			.box-icon {
				font-size: 16px;
				font-weight: bold;
				cursor: pointer;
			}

			img {
				width: 140px;
				height: 100px;
			}

			.box-btn {
				width: 181px;
				height: 35px;
				background: #000000;
				border-radius: 8px;
				color: #FFFFFF;
				font-size: 14px;
				text-align: center;
				line-height: 35px;
				cursor: pointer;
			}
		}
	}

	/**弹出层 */
	.pop {
		width: 300px;
		min-height: 176px;
		padding: 28px 24px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #FFFFFF;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 18px;
		font-weight: bold;
		box-sizing: border-box;
		border-radius: 8px;
		justify-content: center;
		text-align: center;
		z-index: 2000;
		box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);

		img {
			width: 52px;
			height: 52px;
			margin-bottom: 18px;
		}

		p {
			line-height: 1.5;
			word-break: break-word;
		}
	}

	.pc-float {
		display: none;

		@media (min-width: 1280px) {
			display: block;
		}
	}

	@media (max-width: 767px) {
		.product-details {
			overflow-x: hidden;
		}

		.page-header {
			padding-top: env(safe-area-inset-top, 0px);
		}

		.page-header-placeholder {
			height: calc(56px + env(safe-area-inset-top, 0px));
		}

		.home-center-search {
			padding: 16px;
		}

		.home-center-search .search-box {
			height: 44px;

			.search-box-input {
				width: auto;
				flex: 1;
				min-width: 0;
			}

			img {
				width: 16px;
				height: 16px;
				margin-left: 14px;
				margin-right: 8px;
			}

			.search-box-btn {
				padding: 0 16px;
				line-height: 44px;
				flex-shrink: 0;
			}

			input {
				width: 100%;
				font-size: 16px;
			}
		}

		.detail-card {
			margin: 0 16px 16px;
			padding: 0 12px;
			box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);

			&.detail-card-loading {
				min-height: 360px;
			}
		}

		.product-details .main-area {
			display: flex;
			flex-direction: column;
			align-items: stretch;
			gap: 0;
			padding: 16px 0;
		}

		.product-details .main-area .img-area {
			width: 100%;
			max-width: 100%;
			height: auto;
			flex: none;
			flex-shrink: 1;
			flex-direction: column-reverse;
		}

		.left_img {
			width: 100%;
			height: auto !important;
			margin: 10px 0 0;
			display: flex;
			flex-direction: row;
			overflow-x: auto;
			overflow-y: hidden;
			-webkit-overflow-scrolling: touch;
		}

		.left_img img {
			width: 56px !important;
			height: 56px !important;
			margin-right: 8px;
			margin-bottom: 0;
			flex-shrink: 0;
		}

		.product-details .main-area .img-area .goodsimg {
			width: 100% !important;
			max-width: 100%;
			height: auto !important;
			aspect-ratio: 1 / 1;
			object-fit: cover;
		}

		.product-details .main-area .product-info {
			width: 100%;
			flex: none;
			height: auto;
			min-height: 0;
			padding-left: 0;
			padding-top: 16px;
		}

		.product-details .main-area .product-info .title .name {
			font-size: 16px;
		}

		.product-details .main-area .product-info .title .tag {
			margin-left: 0;
			padding: 2px 8px;
			font-size: 12px;
		}

		.product-details .main-area .product-info .main-details .price {
			font-size: 22px;
		}

		.product-details .main-area .product-info .main-details .arrival-time {
			margin-left: 56px;
		}

		.sku_box {
			max-height: 140px;
		}

		.sku_box .sku_item {
			height: auto;
			min-height: 32px;
			padding: 6px 8px;
			margin: 0 8px 8px 0;
			font-size: 13px;
		}

		.num-row {
			flex-wrap: wrap;
		}

		.product-details .main-area .product-info .operation {
			padding-top: 16px;
			gap: 8px;
		}

		.operation-left {
			width: calc(100% - 44px);
			min-width: 0;
		}

		.operation-left .operation-left-l {
			max-width: none;
			margin-left: 10px;
		}

		.operation-left .operation-left-r {
			width: 48px;
			flex-shrink: 0;
		}

		.operation-download {
			max-width: none;
			margin-right: 0;
		}

		.product-details .other-info {
			margin-bottom: 24px;
			padding-bottom: 16px;
			overflow-x: hidden;
		}

		.succeedPop .succeedPop-box {
			width: calc(100vw - 48px);
			max-width: 400px;
			height: auto;
		}

		.pop {
			width: calc(100vw - 48px);
			max-width: 320px;
			min-height: 144px;
			height: auto;
			padding: 20px 16px;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			font-size: 15px;
			line-height: 1.5;
			text-align: center;
			z-index: 2000;

			img {
				width: 44px;
				height: 44px;
				margin-bottom: 16px;
			}

			p {
				word-break: break-word;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/goods/ProductDetails.vue